import React from 'react';
import { withFirebase }  from './Firebase';
import { navigate, Link } from '@reach/router'


class UserNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
  }
  logout = () => {
    this.props.firebase.doSignOut()
      navigate('/login')
  }


  handleNav = () => {
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render() {
    const menuClass = this.state.menuOpen ? 'mobile-nav open' : 'mobile-nav'; 
    return (
      <div id="userNav" className="wrapper">
        <div className="logo">
          <img src='./img/logo.svg' width="75" height="auto" alt="logo"></img>
        </div>
        <button onClick={this.handleNav} style={{ color: '#1976d2' }}><img src="./img/hamburger.svg" alt="open menu" /> </button>
        <div className={menuClass}>
            <button id="close" onClick={this.handleNav}><img src="./img/close.svg" alt="close menu" /></button>
          <div className="container">
            <ul>
              <li><Link to='/budget'>Set Budget</Link></li>
              <li>Add User<br />Coming soon</li>
              <li><Link to='/account'>Account</Link></li>
              <li><button className="logout" onClick={this.logout}>Log Out</button></li>
            </ul>
          </div>
            <span className="copyright" style={{  whiteSpace:"nowrap", position: 'absolute', bottom: '10px', fontSize: "12px", left: '50%', transform: 'translateX(-50%)' }} > Made in <span role="img" aria-label="cactus">🌵</span> San Tan Valley, AZ</span>
        </div> 
      </div>
    )
  }
}

export default withFirebase(UserNav);
